import { type Colors } from '@factorialco/deprecated-design-system'
import { ShiftManagementTemplateWeeksQuery } from 'generated/resources/graphql'

import { getColor } from 'modules/shift_management/lib/getColor'

export type TTemplateWeek =
  ShiftManagementTemplateWeeksQuery['shiftManagement']['templateWeeks'][number]

export interface ITemplateWeek {
  id: string
  name: string
  template_id: string
  position: number
  color: string | null
  template_name: string
  archived: boolean
}
export interface Props {
  id: string
  templateId: string
  name: string
  position: number
  color: Colors | null
  templateName: string
  archived: boolean
}
class TemplateWeek {
  id: string
  templateId: string
  name: string
  position: number
  color: Colors | null
  templateName: string
  archived: boolean

  constructor(props: Props) {
    this.id = props.id
    this.templateId = props.templateId
    this.name = props.name
    this.position = props.position
    this.color = props.color
    this.templateName = props.templateName
    this.archived = props.archived
  }

  static buildFromGraphQL(templateWeek: TTemplateWeek): TemplateWeek {
    const color = getColor(templateWeek.color)

    return new TemplateWeek({
      id: templateWeek.id,
      templateId: templateWeek.templateId,
      name: templateWeek.name,
      position: templateWeek.position,
      color,
      templateName: templateWeek.templateName,
      archived: templateWeek.archived,
    })
  }
}

export default TemplateWeek
